
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"1.091","cy":"1","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"5.091","cy":"1","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"9.091","cy":"1","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"1.091","cy":"15","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"5.091","cy":"15","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"9.091","cy":"15","r":"1","fill":"currentColor"}})])
          )
        }
      }
    